import { HubSortListEntry } from '../hooks/useFetchHubSortList';
import { fetchHubSortListEntries } from './fetchHubSortListEntries';

export async function fetchAndUpdateSortListEntries(
  bundlesId: string[]
): Promise<HubSortListEntry[]> {
  const [hubSortListEntries] = await fetchHubSortListEntries(bundlesId);
  return hubSortListEntries;
}
